module.exports = __webpack_public_path__ + "c043d452e80f09248e19f5557aaadac8.MP3";